module.exports = __webpack_public_path__ + "media/Loops 110 Drums.2aead851.wav";